var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{ref:"header",class:{ 'header--with-bg' : _vm.pageOnTop, 'colored' : _vm.hasColoredBackground }},[_c('desktop-navigation',{attrs:{"header":this}}),_vm._v(" "),_c('mobile-navigation',{attrs:{"header":this}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-da344e60","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TeamsiteHeader.vue
// module id = null
// module chunks = 